import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import { SET_STUDENTS_LOADING, GET_STUDENT_FILES } from "../types";

// GET /students/{mid}/files — список файлов учащегося
export const getStudentFiles = (mid) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students/${mid}/files`);
    const files = data.data || data;
    dispatch({ type: GET_STUDENT_FILES, payload: files });
    return files;
  } catch (ERR) {
    console.error('getStudentFiles error:', ERR);
    return [];
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// GET /students/{mid}/files/{file_name} — скачивание файла (возвращает blob)
export const downloadStudentFile = (mid, fileName) => async () => {
  try {
    const response = await api.get(`/students/${mid}/files/${encodeURIComponent(fileName)}`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (ERR) {
    console.error('downloadStudentFile error:', ERR);
    createNotification('error', 'Ошибка скачивания файла');
    return null;
  }
};

// POST /students/{mid}/files — загрузка файла (FormData)
export const uploadStudentFile = (mid, formData) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.post(`/students/${mid}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    success = true;
    createNotification('success', 'Файл успешно загружен');
    await dispatch(getStudentFiles(mid));
  } catch (ERR) {
    console.error('uploadStudentFile error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка загрузки файла');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// DELETE /students/{mid}/files/{file_name} — удаление файла
export const deleteStudentFile = (mid, fileName) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.delete(`/students/${mid}/files/${encodeURIComponent(fileName)}`);
    success = true;
    createNotification('success', 'Файл успешно удалён');
    await dispatch(getStudentFiles(mid));
  } catch (ERR) {
    console.error('deleteStudentFile error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка удаления файла');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};

// PATCH /students/{mid}/files/{file_name}/rename — переименование файла
export const renameStudentFile = (mid, fileName, newFileName) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.patch(`/students/${mid}/files/${encodeURIComponent(fileName)}/rename`, {
      new_name: newFileName,
    });
    success = true;
    createNotification('success', 'Файл успешно переименован');
    await dispatch(getStudentFiles(mid));
  } catch (ERR) {
    console.error('renameStudentFile error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка переименования файла');
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
    return success;
  }
};
